<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [draggable]="false" [showHeader]="false" [blockScroll]="true" styleClass="w-8rem h-8rem">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" [style]="{'margin':'25px 0px 0px 2px'}"></p-progressSpinner>
</p-dialog>

